"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieROAS = void 0;
const helper_1 = require("./helper");
const cookieROAS = (dateRange, filters) => (0, helper_1.getMetricQuery)(['Attribution.conversions'], dateRange, filters, undefined, [
    {
        measures: [`Attribution.cost`],
    },
    {
        measures: [`Attribution.revenueLNDC`],
    },
], rows => {
    const cost = rows[0].seriesNames().map(s => rows[0].totalRow()[s.key])[0];
    const revenueLNDC = rows[1].seriesNames().map(s => rows[1].totalRow()[s.key])[0];
    return {
        value: (revenueLNDC > 0 ? revenueLNDC / cost : 0) * 100,
        type: 'percent',
    };
});
exports.cookieROAS = cookieROAS;
//# sourceMappingURL=cookieROAS.js.map